$(document).ready(function(){
    if($('.qr-page').length > 0){
        if($('.data-fadein-box-item').length > 0){
            const fadeItems = document.querySelectorAll('.data-fadein-box');
            let iterationSec = 500;
            const observer = new IntersectionObserver(entries =>{
                
                entries.forEach(entrie =>{
                    if(entrie.isIntersecting){
                        if(!$(entrie.target).hasClass('isLoaded')){
                            if($(entrie.target).hasClass('data-fadein-box-fast')){
                                iterationSec = 300;
                            }
                            let elements = $(entrie.target).find('.data-fadein-box-item').sort(function(a, b) {
                                return $(a).attr('class').match(/data-fadein-box-(\d+)/)[1] - 
                                       $(b).attr('class').match(/data-fadein-box-(\d+)/)[1];
                            });
                            $(elements).each(function(index, element) {
                                setTimeout(function() {
                                    $(element).addClass('isLoaded');
                                }, index * iterationSec); 
                            });
                            $(entrie.target).addClass('isLoaded') 
                        }
                            
                    }
                }) 
            }, { threshold: 0.8, rootMargin: "300px" });
            fadeItems.forEach(fadeItem =>{
                observer.observe(fadeItem);
            });
        }
        if($('.data-slide-in-box-item').length > 0){
            const fadeItems = document.querySelectorAll('.data-slide-in-box');
            const observer = new IntersectionObserver(entries =>{
                
                entries.forEach(entrie =>{
                    if(entrie.isIntersecting){
                        if(!$(entrie.target).hasClass('isLoaded')){

                            $(entrie.target).find('.data-slide-in-box-item').addClass('isLoaded') 
                        }
                            
                    }
                }) 
            }, { threshold: 0.8, rootMargin: "300px" });
            fadeItems.forEach(fadeItem =>{
                observer.observe(fadeItem);
            });
        }

    }
})



